import React from 'react';

export default class AppErrorBoundary extends React.Component {
  state = { failed: false };
  static getDerivedStateFromError() { return { failed: true }; }
  render() {
    if (this.state.failed) return <main role="alert" style={{ padding: '2rem' }}>
      <h1>No se pudo abrir esta pantalla</h1>
      <p>Recargá la tienda para obtener la versión actualizada.</p>
      <button onClick={() => window.location.reload()}>Recargar tienda</button>
    </main>;
    return this.props.children;
  }
}
